<ng-container *ngIf="debts$ | async as debts">
	<div class="flex flex-col flex-1 gap-5" *ngIf="debts?.length > 0">
		<div class="flex items-center">
			<h3 class="mr-5">Bills or debts</h3>
			<app-button
				size="small"
				btn="primary"
				[icon]="ICON.ADD"
				size="small"
				(click)="addDebt()"
				[testHook]="testHooks.AddNewBillOrDebtButton"
				>Add new bill or debt</app-button
			>
		</div>
		<div class="flex flex-wrap gap-5">
			<app-container
				class="w-5/12 flex-none"
				*ngFor="let debt of debts$ | async; trackBy: debtId"
				type="light"
				[testHook]="testHooks.Container"
			>
				<div class="p-2">
					<div
						class="flex justify-between pb-4 mb-4 border-b border-grey-light"
					>
						<div class="flex flex-row gap-5 items-center">
							<h4>
								{{
									debt.payee.description?.length > 0
										? debt.payee.description
										: debt.item
								}}
							</h4>
							<app-button
								btn="tertiary"
								[icon]="ICON.EDIT"
								(click)="editDebt(debt)"
								[testHook]="testHooks.EditDebtButton"
							></app-button>
						</div>
						<app-button
							btn="tertiary"
							[holdable]="true"
							[icon]="ICON.DELETE"
							(onClick)="removeDebt(debt)"
							[testHook]="testHooks.DeleteButton"
						></app-button>
					</div>
					<div class="grid grid-cols-2 gap-y-5">
						<div>
							Payee<br />
							<strong>{{ debt.payee.name }}</strong>
						</div>
						<div>
							Item<br />
							<strong>{{ debt.item }}</strong>
						</div>
						<div>
							Amount<br />
							<strong>{{ debt.amount | centsToDollars }}</strong>
						</div>
						<div>
							Follow-up date<br />
							<strong>{{ debt.followUp | date: 'longDate' }}</strong>
						</div>
					</div>
					<div
						class="grid grid-cols-2 gap-3 mt-5"
						*ngIf="useHtmlDocuments$ | async"
					>
						<div
							class="p-4 bg-gray-50 rounded-lg border-gray-400 cursor-pointer transition-shadow hover:shadow flex gap-3"
							(click)="
								openDocument(
									document.id,
									document.groupId,
									document.title,
									debt.payee.name
								)
							"
							*ngFor="let document of documents[debt.id]; trackBy: documentId"
							[testHook]="testHooks.OpenDocumentDiv"
						>
							<app-icon
								classes="text-2xl"
								icon="file"
								[testHook]="testHooks.Icon"
							></app-icon>
							<div>
								{{ document.title }}<br /><small
									>Created: {{ document.createdAt | date }}</small
								><br /><small *ngIf="document.updatedAt"
									>Edited: {{ document.updatedAt | date }}</small
								>
							</div>
						</div>
					</div>
				</div>
			</app-container>
		</div>
	</div>

	<div
		*ngIf="debts?.length === 0"
		class="flex flex-col flex-1 justify-center items-center"
	>
		<div class="empty-state-image">
			<img
				src="assets/images/empty-states/mortgages.svg"
				style="max-width: 500px"
			/>
		</div>
		<h3 class="mt-10">Add new bill or debt</h3>
		<p class="mt-3">Add bills or debts to your matter</p>
		<div class="mt-5">
			<app-button
				[icon]="ICON.ADD"
				size="small"
				(click)="addDebt()"
				[testHook]="testHooks.AddNewBillOrDebtButton1"
				>Add new bill or debt</app-button
			>
		</div>
	</div>
</ng-container>
